"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorResultFromJSON = AuthorResultFromJSON;
exports.AuthorResultFromJSONTyped = AuthorResultFromJSONTyped;
exports.AuthorResultToJSON = AuthorResultToJSON;
exports.AuthorResultToJSONTyped = AuthorResultToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AuthorResultFromJSON(json) {
    return AuthorResultFromJSONTyped(json, false);
}
function AuthorResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': (0, _1.HTTPStatusCodeFromJSON)(json['status']),
        'data': (0, _1.AuthorFromJSON)(json['data']),
        'result': (0, _1.ResultTypeFromJSON)(json['result']),
        'error': !(0, runtime_1.exists)(json, 'error') ? undefined : (0, _1.ErrorDataFromJSON)(json['error']),
    };
}
function AuthorResultToJSON(value) {
    return AuthorResultToJSONTyped(value, false);
}
function AuthorResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': (0, _1.HTTPStatusCodeToJSON)(value.status),
        'data': (0, _1.AuthorToJSON)(value.data),
        'result': (0, _1.ResultTypeToJSON)(value.result),
        'error': (0, _1.ErrorDataToJSON)(value.error),
    };
}
